import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { addEventListener } from '@ifeng-fe/ui_base';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { init, nativeShare } from '@ifeng-fe/container_content/common/client/utils/nativeShare';

class Dialog extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        docData: PropTypes.object,
        closeFn: PropTypes.func,
    };

    handleClick = e => {
        const { docData } = this.props;
        const config = {
            url: docData.pcUrl ? docData.pcUrl : '',
            title: docData.title ? docData.title : '',
            desc: docData.summary ? docData.summary : '',
            img:
                docData.imagesInContent && docData.imagesInContent[0] && docData.imagesInContent[0].url
                    ? docData.imagesInContent[0].url
                    : '',
            img_title: '',
            from: docData.source ? docData.docData : '',
            summary: docData.summary ? docData.summary : '',
        };
        const from = window.location.search.indexOf('?ch=qd_hw_fyp1') !== -1;
        const dataApp = e.currentTarget.attributes['data-app'].value;

        nativeShare(config, from, dataApp);

        e.stopPropagation();
    };

    render() {
        const { closeFn, content } = this.props;
        const type = init();

        return ReactDOM.createPortal(
            <div className={styles.box}>
                <div className={styles.mainBox}>
                    <div className={styles.shareBox}>
                        {type === 'all' ? (
                            <React.Fragment>
                                <div>
                                    <span data-app="weixin" className={styles.wx} onClick={this.handleClick} />
                                    <span>微信</span>
                                </div>
                                <div>
                                    <span data-app="weixinFriend" className={styles.pyq} onClick={this.handleClick} />
                                    <span>朋友圈</span>
                                </div>
                                <div>
                                    <span data-app="sinaWeibo" className={styles.wb} onClick={this.handleClick} />
                                    <span>微博</span>
                                </div>
                                <div>
                                    <span data-app="QQ" className={styles.qq} onClick={this.handleClick} />
                                    <span>QQ</span>
                                </div>
                                <div>
                                    <span data-app="QZone" className={styles.qqzone} onClick={this.handleClick} />
                                    <span>QQ空间</span>
                                </div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div>
                                    <span data-app="sinaWeibo" className={styles.wb} onClick={this.handleClick} />
                                    <span>微博</span>
                                </div>
                                <div>
                                    <span data-app="QZone" className={styles.qqzone} onClick={this.handleClick} />
                                    <span>QQ空间</span>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                    <div className={styles.downloadBox}>
                        {content.map((item, index) => (
                            <div key={index}>
                                <a
                                    href={item.url}
                                    data-flag={item.flag}
                                    onClick={this.statisticsHandle}
                                    style={{ backgroundImage: `url(${item.icon})` }}
                                />
                                <span>{item.title}</span>
                            </div>
                        ))}
                    </div>
                    <div className={styles.close} onClick={closeFn}>
                        <span>取消</span>
                    </div>
                </div>
            </div>,
            document.body,
        );
    }
}

export default errorBoundary(Dialog);
